// extracted by mini-css-extract-plugin
export default {"shipping_address_container":"gqGT","shipping_address_title":"_2izA","shipping_address_item_holder":"_3B45","shipping_address_item":"_280M"};